import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/team-name-stacking/actions';
import Const from 'constants';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class SetMaxForAllTeamsSettings extends Component {
    constructor(props) {
        super(props);
        this.signature = null;
        this.state = {maxPlayers: 0};
    }

    componentDidUpdate(prevProps) {
        const {stacking} = this.props;

        if (stacking.getSignature() !== this.signature) {
            this.signature = stacking.getSignature();
            this.setState({maxPlayers: 0});
        }
    }

    getMaxPlayers() {
        const {sportConfig} = this.props;

        return sportConfig.getConfigProp('maxSingleTeamPlayers', Const.MIN_PLAYERS_IN_TEAM_STACK);
    }

    onChange(value) {
        this.setState({maxPlayers: Number(value)});
    }

    onClick() {
        const {activeTeamNames} = this.props;

        this.props.dispatch(Action.setMaxPlayersForTeams(this.state.maxPlayers, activeTeamNames));
    }

    getOptions() {
        const minValue = 0;
        const maxValue = this.getMaxPlayers();
        const options = {};

        for (let i = minValue; i <= maxValue; i++) {
            options[i] = `${i} ${1 === i ? 'Player' : 'Players'}`;
        }

        return options;
    }

    render() {
        return (
            <div className="team-limits-top-form">
                <label>Set max for all teams</label>
                <div className="input-group">
                    <SimpleSelect
                        key={this.state.maxPlayers}
                        className="form-control"
                        value={this.state.maxPlayers}
                        options={this.getOptions()}
                        onChange={::this.onChange}
                    />
                    <div className="input-group-btn">
                        <button onClick={() => this.onClick()} type="button" className="btn">
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        stacking: state.teamNameStacking,
        activeTeamNames: state.playersData.filters.games,
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(SetMaxForAllTeamsSettings);
